export const GET_PUBLISHED_JOBS = " GET_PUBLISHED_JOBS"
export const  GET_PUBLISHED_JOBS_SUCCESSFULL = " GET_PUBLISHED_JOB_SUCCESSFULL"
export const  GET_PUBLISHED_JOBS_FAILED = " GET_PUBLISHED_JOBS_FAILED"

export const GET_RECRUITMENT_DATA = "GET_RECRUITMENT_DATA"
export const GET_RECRUITMENT_DATA_SUCCESSFULL =  " GET_RECRUITMENT_DATA_SUCCESSFULL"
export const GET_RECRUITMENT_DATA_FAILED = "GET_RECRUITMENT_DATA_FAILED"

export const GET_DASHBOARD_CARDS_DATA = "GET_DASHBOARD_CARDS_DATA"
export const GET_DASHBOARD_CARDS_DATA_SUCCESS = "GET_DASHBOARD_CARDS_DATA_SUCCESS" 
export const GET_DASHBOARD_CARDS_DATA_FAILED = "GET_DASHBOARD_CARDS_DATA_FAILED"

export const GET_DASHBOARD_TOTALINTERVIEW_DATA = "GET_DASHBOARD_TOTALINTERVIEW_DATA"
export const GET_DASHBOARD_TOTALINTERVIEW_DATA_SUCCESS = "GET_DASHBOARD_TOTALINTERVIEW_DATA_SUCCESS"
export const GET_DASHBOARD_TOTALINTERVIEW_DATA_FAILED = "GET_DASHBOARD_TOTALINTERVIEW_DATA_FAILED"

export const GET_NEW_CANDIDATES_DATA = "GET_NEW_CANDIDATES_DATA"
export const GET_NEW_CANDIDATES_DATA_SUCCESS = "GET_NEW_CANDIDATES_DATA_SUCCESS"
export const GET_NEW_CANDIDATES_DATA_FAILED = "GET_NEW_CANDIDATES_DATA_FAILED"

export const GET_RECRUITMENT_REPORT = "GET_RECRUITMENT_REPORT"
export const GET_RECRUITMENT_REPORT_SUCCESS = "GET_RECRUITMENT_REPORT_SUCCESS"
export const GET_RECRUITMENT_REPORT_FAILED = "GET_RECRUITMENT_REPORT_FAILED"

export const GET_JOB_STATUS_DATA = "GET_JOB_STATUS_DATA"
export const GET_JOB_STATUS_DATA_SUCCESS = "GET_JOB_STATUS_DATA_SUCCESS"
export const GET_JOB_STATUS_DATA_FAILED = " GET_JOB_STATUS_DATA_FAILED"

export const GET_JOB_STATUS_FILTER_DATA = "GET_JOB_STATUS_FILTER_DATA"


export const GET_UPCOMING_INTERVIEWS_DATA = " GET_UPCOMING_INTERVIEWS_DATA"
export const GET_UPCOMING_INTERVIEWS_DATA_SUCCESS = " GET_UPCOMING_INTERVIEWS_DATA_SUCCESS"
export const GET_UPCOMING_INTERVIEWS_DATA_FAIL = " GET_UPCOMING_INTERVIEWS_DATA_FAIL"


export const GET_UPCOMING_INTERVIEWS_FILTER_DATA = " GET_UPCOMING_INTERVIEWS_FILTER_DATA"
export const GET_UPDATE_INTERVIEW = "GET_UPDATE_INTERVIEW"
export const GET_UPDATE_INTERVIEW_SUCCESS = "GET_UPDATE_INTERVIEW_SUCCESS"
export const GET_UPDATE_INTERVIEW_FAIL = "GET_UPDATE_INTERVIEW_FAIL"


export const GET_JOB_COMPLETION_STATUS = "GET_JOB_COMPLETION_STATUS"
export const GET_JOB_COMPLETION_STATUS_SUCCESS = "GET_JOB_COMPLETION_STATUS_SUCCESS"
export const GET_JOB_COMPLETION_STATUS_FAIL = "GET_JOB_COMPLETION_STATUS_FAIL"


export const GET_UPCOMING_INTERVIEW_SUGGESTIONS = "GET_UPCOMING_INTERVIEW_SUGGESTIONS"
export const GET_UPCOMING_INTERVIEW_SUGGESTIONS_SUCCESS = "GET_UPCOMING_INTERVIEW_SUGGESTIONS_SUCCESS"
export const GET_UPCOMING_INTERVIEW_SUGGESTIONS_FAIL = "GET_UPCOMING_INTERVIEW_SUGGESTIONS_FAIL"


export const GET_JOBSTATUS_SUGGESTIONS = "GET_JOBSTATUS_SUGGESTIONS"
export const GET_JOBSTATUS_SUGGESTIONS_SUCCESS = "GET_JOBSTATUS_SUGGESTIONS_SUCCESS"
export const GET_JOBSTATUS_SUGGESTIONS_FAIL = "GET_JOBSTATUS_SUGGESTIONS_FAIL"

//recruitment agency chart action type

export const GET_CLIENT_JOBS = "GET_CLIENT_JOBS"
export const GET_CLIENT_JOBS_SUCCESS = "GET_CLIENT_JOBS_SUCCESS"
export const GET_CLIENT_JOBS_FAIL = "GET_CLIENT_JOBS_FAIL"

export const GET_CANDIDATE_HIRE = "GET_CANDIDATE_HIRE"
export const GET_CANDIDATE_HIRE_SUCCESS = "GET_CANDIDATE_HIRE_SUCCESS"
export const GET_CANDIDATE_HIRE_FAIL = "GET_CANDIDATE_HIRE_FAIL"

//interview process page view modal api
export const GET_INTERVIEW_PROCESS_MODAL_DATA = "GET_INTERVIEW_PROCESS_MODAL_DATA"
export const GET_INTERVIEW_PROCESS_MODAL_DATA_SUCCESS = "GET_INTERVIEW_PROCESS_MODAL_DATA_SUCCESS"
export const GET_INTERVIEW_PROCESS_MODAL_DATA_FAIL = "GET_INTERVIEW_PROCESS_MODAL_DATA_FAIL"

